/**
 * Minimal DOM helpers for shell (no business logic).
 */

export type CreateElAttrs = Record<
  string,
  string | Record<string, string> | ((e: Event) => void)
>;

/**
 * Create an element with optional attributes (className, html, style, on* handlers, data-*, etc.).
 */
export function createEl<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: CreateElAttrs = {}
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (k === 'className') el.className = String(v);
    else if (k === 'html') el.innerHTML = String(v);
    else if (k === 'style' && typeof v === 'object' && v !== null && !Array.isArray(v))
      Object.assign(el.style, v as Record<string, string>);
    else if (k.startsWith('on') && typeof v === 'function')
      el.addEventListener(k.slice(2).toLowerCase(), v as (e: Event) => void);
    else if (k !== 'style') el.setAttribute(k, String(v));
  }
  return el as HTMLElementTagNameMap[K];
}
